"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { VISIT_PATH, visitBeaconNeeded, type VisitReport } from "@/lib/visit-beacon";

/**
 * Reports the page view to /api/visit when it would change the visitor's
 * cookies (lib/visit-beacon.ts). Mounted by the root layout only on a render
 * nginx may serve from the marketing cache, where the proxy mints nothing.
 * Re-checks on client-side navigation, so following a link into /sv still
 * moves the stored language preference, as a proxied page view would.
 * Renders nothing.
 */
export function VisitBeacon() {
  const pathname = usePathname();
  useEffect(() => {
    if (!visitBeaconNeeded({ cookies: document.cookie, pathname, search: window.location.search })) return;
    const report: VisitReport = { href: window.location.href, referrer: document.referrer };
    void fetch(VISIT_PATH, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(report),
      keepalive: true,
    }).catch(() => undefined);
  }, [pathname]);
  return null;
}
